{
  "version": 1,
  "asset_id": "18fab2d4-4644-4a39-919c-a54ae25d8c99",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/18fab2d4-4644-4a39-919c-a54ae25d8c99/crystal-river-blue-shingle-roof-destination-roofing-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/18fab2d4-4644-4a39-919c-a54ae25d8c99/crystal-river-blue-shingle-roof-destination-roofing-480w.webp",
  "original_filename": "crystal-river-blue-shingle-roof-destination-roofing-480w.webp",
  "size": 21676,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:47Z"
}
